import { render, staticRenderFns } from "./CategoryMainSlider.vue?vue&type=template&id=9be5dc44&scoped=true"
import script from "./CategoryMainSlider.vue?vue&type=script&lang=js"
export * from "./CategoryMainSlider.vue?vue&type=script&lang=js"
import style0 from "./CategoryMainSlider.vue?vue&type=style&index=0&id=9be5dc44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be5dc44",
  null
  
)

export default component.exports